export default __webpack_public_path__ + "static/media/taller-c++.34777258.png";